import { FaRegSave } from "react-icons/fa"

const ReleaseButton = () => {
  return <button className=" flex items-center gap-2 border rounded px-3 py-2 bg-primary text-[#fff]">
    {/* icon */}
    <FaRegSave />
    {/* text */}
    Release
  </button>
}

export default ReleaseButton